import { render } from "./Studio.vue?vue&type=template&id=5e7593cb&scoped=true&ts=true"
import script from "./Studio.vue?vue&type=script&lang=ts"
export * from "./Studio.vue?vue&type=script&lang=ts"

import "./Studio.vue?vue&type=style&index=0&id=5e7593cb&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7593cb"]])

export default __exports__